import { useListContext, useRecordContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterBar, FilterBarActions, FilterBarRow } from 'shared/mui/Filter/FilterBar';
import { FilterApplyButton, FilterResetButton } from 'shared/mui/Filter/FilterButtons';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import { AutocompleteInput, TextInput } from 'shared/react-admin/Inputs';
import { Merchant } from 'types/embedded/merchant';

import { useUniqueProvidersFromCredentials } from './hooks/useUniqueProvidersFromCredentials';

type MerchantsShowCredentialsFilterValues = { name: string | null };

const DEFAULT_FORM_VALUES = {
  name: null,
  provider: null,
};

export const MerchantsShowCredentialsFilters: React.FC = () => {
  const record = useRecordContext<Merchant>();
  const { filterValues } = useListContext();

  const { form, onReset, onSubmit, appliedFilters } =
    useFilters<MerchantsShowCredentialsFilterValues>({
      defaultValues: { ...DEFAULT_FORM_VALUES, ...filterValues },
      resetValues: DEFAULT_FORM_VALUES,
    });

  useSyncFilter<MerchantsShowCredentialsFilterValues>({ appliedFilters });

  const { providers, isLoading } = useUniqueProvidersFromCredentials(record?.id);

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FilterBar>
          <FilterBarRow sx={{ gridTemplateColumns: '1fr 1fr 272px' }}>
            <TextInput
              helperText={false}
              key="name"
              label="Название"
              name="name"
              source="name"
              variant="outlined"
            />
            <AutocompleteInput
              choices={providers}
              helperText={false}
              isLoading={isLoading}
              label="Провайдер"
              name="provider"
              optionText="name"
              optionValue="id"
              source="provider"
              variant="outlined"
            />
            <FilterBarActions>
              <FilterResetButton onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterBarActions>
          </FilterBarRow>
        </FilterBar>
      </form>
    </FormProvider>
  );
};
